import { z } from 'zod';

export const AnalyticsMetricSchema = z.object({
    last_30_days: z.number(),
    all_time: z.number(),
});

/**
 * Expert analytics data schema.
 * Note: createEndpoint automatically unwraps the { success, data } wrapper,
 * so this schema validates the inner data object directly.
 */
export const ExpertAnalyticsSchema = z.object({
    leads_count: AnalyticsMetricSchema,
    cta_clicks: AnalyticsMetricSchema,
    impressions: AnalyticsMetricSchema,
    listing_visits: AnalyticsMetricSchema,
    unique_visits: AnalyticsMetricSchema,
    outbound_clicks: AnalyticsMetricSchema,
});

export type AnalyticsMetric = z.infer<typeof AnalyticsMetricSchema>;
export type ExpertAnalytics = z.infer<typeof ExpertAnalyticsSchema>;
